import { Component, Input } from '@angular/core';
import { BaseAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-visit-detail-expired-products',
  templateUrl: './visit-detail-expired-products.component.html',
  styleUrls: ['./visit-detail-expired-products.component.scss'],
})
export class VisitDetailExpiredProductsComponent extends BaseAccordionComponent {
  @Input() expiredProducts;

  constructor(accordionService: AccordionService) {
    super(accordionService);
  }
}
